exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SectionBox-5d48cfde{margin:0 0 30px 0}.SectionContent-e146dfe5{padding:20px;background:#FFF;box-shadow:1px 1px 8px rgba(0,0,0,0.15);border-radius:5px}.noPadding-2bffd9dc .SectionContent-e146dfe5{padding:0 0}.flexHeader-02f79980{display:flex;align-items:center;justify-content:space-between}.flexHeader-02f79980 h2{align-self:flex-end}.flexLeft-cd7d6738{align-self:flex-start}.flexRight-26016835{align-self:flex-end;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"SectionBox": "SectionBox-5d48cfde",
	"SectionContent": "SectionContent-e146dfe5",
	"noPadding": "noPadding-2bffd9dc",
	"flexHeader": "flexHeader-02f79980",
	"flexLeft": "flexLeft-cd7d6738",
	"flexRight": "flexRight-26016835"
};